import React from 'react';
import { motion } from 'framer-motion';
import { MessageSquare, Zap } from 'lucide-react';
export function EliteUpsell() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-94">
      <div className="max-w-content mx-auto" data-id="element-95">
        <div className="text-center mb-16" data-id="element-96">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-4" data-id="element-97">
            ¿Qué agrega el Megapack Élite?
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-gray-600 font-medium" data-id="element-98">
            Por solo $11.000 más, llevás tu trabajo al siguiente nivel.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-99">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gray-50 rounded-2xl p-8 border border-gray-200 hover:border-f360-gold transition-colors" data-id="element-100">
            <div className="w-14 h-14 bg-white rounded-xl shadow-sm border border-gray-100 flex items-center justify-center mb-6" data-id="element-101">
              <MessageSquare className="w-7 h-7 text-f360-gold" data-id="element-102" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-103">
              💬 Élite 1 — Manual del DT Profesional
            </h3>
            <p className="text-gray-600 leading-relaxed text-lg" data-id="element-104">
              El escudo protector del profe. Protocolos antiquejas, scripts de
              WhatsApp, guion de la primera reunión con padres y cómo justificar
              tu trabajo frente al club. Dejá de ser "el que pone los conos" y
              convertite en el DT al que todos respetan.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gray-50 rounded-2xl p-8 border border-gray-200 hover:border-f360-gold transition-colors" data-id="element-105">
            <div className="w-14 h-14 bg-white rounded-xl shadow-sm border border-gray-100 flex items-center justify-center mb-6" data-id="element-106">
              <Zap className="w-7 h-7 text-f360-gold" data-id="element-107" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-108">
              🎯 Élite 2 — 100 Variantes Dinámicas
            </h3>
            <p className="text-gray-600 leading-relaxed text-lg" data-id="element-109">
              El arsenal creativo definitivo. 100 variantes para rondos, juegos
              cognitivos, duelos de definición, circuitos y espacios reducidos.
              Nunca más el grupo va a decir "¿otra vez lo mismo?". El banco de
              recursos para levantar la energía en 30 segundos.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}